import { FC } from "react";
import RootModal from "../rootModal";

type PrecertModalProps = {
  title: string;
  isModalVisible: boolean;
  hideModal: (isCancelled: boolean) => void;
}


const PrecertModal: FC<PrecertModalProps> = ({ title, isModalVisible, hideModal }): JSX.Element => {
  return (
    <RootModal isModalVisible={isModalVisible} hideModal={() => hideModal(true)}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-body">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="text-center">
                  <i className="bi bi-exclamation-circle-fill text-warning fs-1"></i>
                </div>
                <h3 className="text-center fs-5">{title}</h3>
              </div>
              <div className="col-12 text-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary btn-lg px-5 me-2"
                  data-bs-dismiss="modal"
                  onClick={() => hideModal(true)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-lg px-5"
                  data-bs-dismiss="modal"
                  onClick={() => hideModal(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </RootModal>
  )
}

export default PrecertModal
